import { render } from "./FDLayout.vue?vue&type=template&id=3af6efd2&scoped=true"
import script from "./FDLayout.vue?vue&type=script&lang=js"
export * from "./FDLayout.vue?vue&type=script&lang=js"

import "./FDLayout.vue?vue&type=style&index=0&id=3af6efd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af6efd2"]])

export default __exports__